/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagLabPanel from './diag-lab-panel';
import DiagLabPanelDetail from './diag-lab-panel-detail';
import DiagLabPanelUpdate from './diag-lab-panel-update';
import DiagLabPanelDeleteDialog from './diag-lab-panel-delete-dialog';

const DiagLabPanelRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagLabPanel />} />
    <Route path="new" element={<DiagLabPanelUpdate />} />
    <Route path=":id">
      <Route index element={<DiagLabPanelDetail />} />
      <Route path="edit" element={<DiagLabPanelUpdate />} />
      <Route path="delete" element={<DiagLabPanelDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagLabPanelRoutes;
